import React from 'react';
import TimeField from 'components/pure/utils/form/TimeField';
import DaysOfWeekSelector from 'components/pure/utils/form/DaysOfWeekSelector';
import RecurrenceEndSelector from './RecurrenceEndSelector';
import InputField from 'components/pure/utils/form/InputField';
import pick from 'lodash/pick';
import {validate} from 'records/CoachingPlan';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import './SchedulingStep.styl';
import {RECURRENCE_COUNT_TYPE, RECURRENCE_END_DATE_TYPE} from 'records/EventSchedule';
import {FindTimeContainer} from '@components/calendar/FindTimeContainer';
import {DateOptionsArr} from '@store/@types/util/time/DayOfWeek';
import Time from 'records/Time';

export default class SchedulingStep extends React.PureComponent {
  static title = 'Scheduling';

  static validate(plan) {
    return pick(validate(plan).schedule, [
      'weeksBetween',
      'daysOfWeek',
      'time',
      RECURRENCE_COUNT_TYPE,
      RECURRENCE_END_DATE_TYPE,
    ]);
  }

  render() {
    const {model: coachingPlan, onChange, showErrors} = this.props;
    const {schedule} = coachingPlan;
    const errors = SchedulingStep.validate(coachingPlan);

    const firstChosenDayOfWeek = !coachingPlan.schedule.daysOfWeek.isEmpty()
      ? coachingPlan.schedule.daysOfWeek
          .sortBy(day => DateOptionsArr.findIndex(x => x.label === day))
          .first()
          .toUpperCase()
      : undefined; // Undefined will fallback to default today's day in FindTimeLink component.

    const desiredHour = `${coachingPlan.schedule.time.hour}`.padStart(2, '0');
    const desiredMinute = `${coachingPlan.schedule.time.minute}`.padStart(2, '0');
    const desiredMeetingTime = `${desiredHour}:${desiredMinute}`;

    const findTimeChoiceMade = chosenFindTime => {
      onChange(
        coachingPlan
          .setIn(
            ['schedule', 'time'],
            new Time({
              hour: chosenFindTime.hour,
              minute: chosenFindTime.minutes,
            })
          )
          .setIn(
            ['schedule', 'daysOfWeek'],
            coachingPlan.schedule.daysOfWeek.includes(chosenFindTime.day)
              ? coachingPlan.schedule.daysOfWeek
              : coachingPlan.schedule.daysOfWeek.push(chosenFindTime.day)
          )
      );
    };

    return (
      <div className="coaching-step coaching-plan-wizard-scheduling-step">
        <p>When and how often would you like to meet?</p>
        <div className="form">
          <FieldContainer
            label={'Meet every'}
            labelType="div"
            error={
              showErrors
                ? errors.weeksBetween ||
                  (errors.time && Object.entries(errors.time).find(([_, value]) => value)[1])
                : null
            }>
            <div className="recurrence-value">
              <InputField
                value={schedule.weeksBetween || ''}
                type="number"
                size={4}
                min={1}
                onChange={value =>
                  onChange(coachingPlan.set('schedule', schedule.set('weeksBetween', value)))
                }
              />
              <label>
                week
                {!schedule.weeksBetween || schedule.weeksBetween > 1 ? 's' : ''} at
              </label>
              <TimeField
                value={schedule.time}
                onChange={value =>
                  onChange(coachingPlan.set('schedule', schedule.set('time', value)))
                }
              />
              <FindTimeContainer
                coachUserId={coachingPlan.coach?.id}
                recipientUserId={coachingPlan.recipient?.id}
                recipientFirstName={coachingPlan.recipient?.info?.firstName}
                meetingMinutes={coachingPlan.schedule.durationInMinutes}
                searchWeeks={
                  coachingPlan.schedule.weeksBetween * coachingPlan.schedule.recurrenceCount
                }
                dayOfWeek={firstChosenDayOfWeek}
                desiredTime={desiredMeetingTime}
                findTimeChoiceMade={findTimeChoiceMade}
              />
            </div>
          </FieldContainer>
          <FieldContainer
            label={'Repeat on'}
            labelType="div"
            error={showErrors ? errors.daysOfWeek : null}>
            <DaysOfWeekSelector
              onChange={value =>
                onChange(coachingPlan.set('schedule', schedule.set('daysOfWeek', value)))
              }
              value={schedule.daysOfWeek}
            />
          </FieldContainer>
          <FieldContainer className="recurrent-end-field" label={'Ends'} labelType="div">
            <RecurrenceEndSelector
              schedule={coachingPlan.schedule}
              errors={errors}
              showErrors={showErrors}
              onChange={schedule => onChange(coachingPlan.set('schedule', schedule))}
            />
          </FieldContainer>
        </div>
      </div>
    );
  }
}
